import { type FunctionComponent } from "react";

import PageLayout from "../core/navigation-panel/PageLayout.js";
import { type IRouteNavItemProps } from "../core/navigation-panel/RouteNavItem.js";
import { AdminPlaybookCategoriesTable } from "./AdminPlaybookCategoriesTable.js";
import { AdminPlaybooksTable } from "./AdminPlaybooksTable.js";

export const PLAYBOOKS_ADMIN_MENU_ITEMS: IRouteNavItemProps[] = [
  {
    label: "Playbooks",
    route: "playbooks",
    pageComponent: <AdminPlaybooksTable />,
    default: true,
  },
  {
    label: "Categories",
    route: "categories",
    pageComponent: <AdminPlaybookCategoriesTable />,
  },
];

/**
 * Samples Admin Page main component
 */
const PlaybooksAdminPage: FunctionComponent = () => {
  return (
    <PageLayout
      navPanelCategories={[
        {
          label: "Playbooks Administration",
          navItems: PLAYBOOKS_ADMIN_MENU_ITEMS,
        },
      ]}
    />
  );
};

export default PlaybooksAdminPage;
